import React, { useState } from "react";
import { colors } from "../../../themes/Colors";

const BaseButtonsIcon = ({
  label,
  width,
  borderRadius,
  backgroundColor,
  onClick,
  icon,
  iconHeight,
  iconWidth,
  shrink,
  marginTop,
  shrinkColor,
  hoverColor,
  icon2,
  height,
  disable,
}) => {
  const [hover, setHover] = useState(false);
  return (
    <button
      onMouseOver={() => setHover(true)}
      onMouseOut={() => setHover(false)}
      onClick={onClick}
      disabled={disable}
      style={{
        height: shrink ? 50 : height ? height : 50,
        width: shrink ? 50 : width,
        borderRadius: borderRadius,
        backgroundColor: shrink
          ? hover
            ? hoverColor
            : shrinkColor
          : hover
          ? hoverColor
          : backgroundColor,
        borderWidth: 0,
        //WebkitBoxShadow: "-5px 5px 15px -1px #00000070",
        color: colors.white,
        fontWeight: "bold",
        transition: shrink
          ? "backgroundColor, width 0.3s"
          : "backgroundColor, width  0.3s",
        opacity: disable ? 0.5 : hover ? (hoverColor ? 1 : 0.7) : 1,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        marginTop: marginTop,
      }}
    >
      {label ? (
        shrink ? null : (
          <div
            style={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
            }}
          >
            <div style={{ marginLeft: 5, textAlign: "left" }}> {label}</div>
          </div>
        )
      ) : null}
      {icon ? <div style={{ flex: 1 }} /> : null}
      {icon ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginRight: shrink ? 3 : 5,
          }}
        >
          <img
            alt="icon"
            src={hover ? icon2 : icon}
            style={{ height: iconHeight, width: iconWidth }}
          />
        </div>
      ) : null}
    </button>
  );
};

export default BaseButtonsIcon;
